import React from "react";

export const checkApprover = (itemInEdit, setItemInEdit, setInitialApprover, setIsApproverExists, validationObj, setValidationObj, user, api, apiUrl, setLoading, lodashFunc, onCheckFinished = null) => {
    const approverErrorCheck = (data) => {
        const checkResult = data !== null && (data?.approver || data?.autoApproved);
        setIsApproverExists(checkResult);
            // console.log(data);
        const errors = [...validationObj];
        const itemType = `approver`;
        const exists = lodashFunc.some(errors, (item) => item.type === itemType);
        if (!checkResult && !exists)
            errors.push({ type: itemType, message: (
                <span>Incomplete approver list for the selected Project. Please contact HRIS Administrator to go to Maintenance {">"} Project to setup the approver list or click <u className="cursor-pointer" onClick={() => window.open(`/maintenance`, '_blank')}>here</u> if you have Administrator access.</span>
            ) });

        if (checkResult && exists)
            lodashFunc.remove(errors, (item) => item.type === itemType);

        setValidationObj([...errors]);

        if (checkResult)
        {
            setInitialApprover(data.autoApproved ? `${user.username} (auto approved)` : data.approver?.displayName);

            if (itemInEdit.approverName && (itemInEdit.status?.lookupValue.toLowerCase().includes("rejected") || itemInEdit.status?.lookupValue.toLowerCase().includes("declined")))
                setItemInEdit({...itemInEdit, approverName: null, approverEmail: null, autoApproved: data.autoApproved});

            if (!(itemInEdit.status?.lookupValue.toLowerCase().includes("rejected") || itemInEdit.status?.lookupValue.toLowerCase().includes("declined")))
                setItemInEdit({...itemInEdit, approverName: data.approver?.displayName, approverEmail: data.approver?.email, autoApproved: data.autoApproved});
        }

        if (onCheckFinished)
            onCheckFinished();
    };

    setInitialApprover(null);
    if (!itemInEdit?.projectId)
    {
        setIsApproverExists(false);

        if (onCheckFinished)
            onCheckFinished();

        return;
    }
    setLoading(true);

    api.get(`${apiUrl}/approval/check?projectId=${itemInEdit.projectId}`)
        .then((response) => {
            const {data} = response;
            approverErrorCheck(data);
        })
        .catch((error) => console.error({error}))
        .finally(() => setLoading(false))
    ;
};

export const getDefaultSelectedAllocation = (itemInEdit, rows) => {
    const result = rows
        .filter((row) => {
            return row.projectId === itemInEdit?.projectId &&
                row.positionId === itemInEdit?.positionId;
            }
        )
        .reduce((acc, row) => {
            acc[row.candidateAllocationId] = true;
            return acc;
        }, {});
    return result;
};

export const validate = (itemInEdit, isFinal, isApproval) => {
    const validationResult = [];

    if (!itemInEdit.candidateId)
        validationResult.push({
            type: "error",
            message: "Employee Name must be filled.",
        });

    if (!itemInEdit.projectId)
        validationResult.push({
            type: "error",
            message: "Project must be filled.",
        });

    if (!itemInEdit.positionId)
        validationResult.push({
            type: "error",
            message: "Position must be filled.",
        });

    if (!itemInEdit.companyId)
        validationResult.push({
            type: "error",
            message: "Entity must be filled.",
        });

    if (!itemInEdit.recruitmentTypeId)
        validationResult.push({
            type: "error",
            message: "Recruitment Type must be filled.",
        });

    if (!itemInEdit.employmentTypeId)
        validationResult.push({
            type: "error",
            message: "Employment Type must be filled.",
        });

    if (!itemInEdit.managerId)
        validationResult.push({
            type: "error",
            message: "Manager must be filled.",
        });

    if (!itemInEdit.notificationDate)
        validationResult.push({
            type: "error",
            message: "Date of Notification must be filled.",
        });

    if (!itemInEdit.lastDayEmploymentDate)
        validationResult.push({
            type: "error",
            message: "Last Day of Employment must be filled.",
        });

    if (!itemInEdit.lastDayWorkDate)
        validationResult.push({
            type: "error",
            message: "Last Day of Working must be filled.",
        });

    if (!itemInEdit.reasonId)
        validationResult.push({
            type: "error",
            message: "Termination Reason must be filled.",
        });

    if (itemInEdit.reason?.lookupValue === "Redundancy" && itemInEdit.lieuNotice === null)
        validationResult.push({
            type: "error",
            message: "Pay Notice in Lieu must be filled.",
        });

    if (itemInEdit.reason?.lookupValue === "Resignation" && (!itemInEdit.reasonDetailId || !itemInEdit.terminationAttachments?.length))
        validationResult.push({
            type: "error",
            message: "Resignation Reason and Supporting Document must be filled.",
        });

    if (itemInEdit.reason?.lookupValue === "Moved to New Project" && !itemInEdit.recruitmentRequestId)
        validationResult.push({
            type: "error",
            message: "Recruitment Request must be filled.",
        });

    if (itemInEdit?.terminationAssessmentItems?.filter(c => c.isYesNo && c.assessmentValue !== null && !c.assessmentValue && !c.declineReason).length)
        itemInEdit.terminationAssessmentItems.filter(c => c.isYesNo && c.assessmentValue !== null && !c.assessmentValue && !c.declineReason).forEach(t => {
            validationResult.push({
                type: "error",
                message: `Reason for ${t.employeeAssessmentItemName} must be filled.`,
            });
        });

    if (isFinal && !isApproval && itemInEdit?.redundancyEntitlements && !itemInEdit?.redundancyEntitlementsNotes)
        validationResult.push({
            type: "error",
            message: "Redundancy Entitlements notes must be filled.",
        });

    return validationResult;
};

export const composeDataToSend = (itemInEdit, submitApproval, isFinal = false, saveOnApproval = false, approvalId = null, approved = false) => {
    const formData = new FormData();
    formData.append("lieuNotice", itemInEdit.lieuNotice !== null ? (itemInEdit.lieuNotice ? true : false) : "");
    formData.append("generateApproval", submitApproval);
    formData.append("isFinal", isFinal);

    for (let key in itemInEdit) {
        if (
            key !== "terminationAttachments" &&
            key !== "deletedTerminationAttachments" &&
            key !== "terminationAssessmentItems" &&
            key !== "lieuNotice" &&
            key !== "generateApproval" &&
            key !== "isFinal" &&
            key !== "approved" &&
            key !== "terminationApprovalId" &&
            key !== "includeApprovalProcess" &&
            key !== "statusValue" &&
            key !== "approvalReason"
        ) {
            if (typeof itemInEdit[key] === "object")
                continue;

            if (itemInEdit[key] !== undefined)
                formData.append(`${key}`, itemInEdit[key]);

            continue;
        }

        if (key === "terminationAttachments" && itemInEdit.terminationAttachments) {
            itemInEdit.terminationAttachments.forEach((d, idx) => {
                // console.log(d);
                formData.append(`${key}[${idx}].terminationAttachmentId`, d.terminationAttachmentId);
                formData.append(`${key}[${idx}].terminationId`, d.terminationId ?? 0);

                if (d.file) {
                    // console.log(d.file);
                    formData.append(`${key}[${idx}].file`, d.file);
                    formData.append(`${key}[${idx}].fileContent`, null);
                    formData.append(`${key}[${idx}].fileContentType`, "");
                    formData.append(`${key}[${idx}].fileLength`, 0);
                    formData.append(`${key}[${idx}].filename`, "");
                    return;
                }

                // console.log(d.file);
                formData.append(`${key}[${idx}].fileContent`, d.fileContent);
                formData.append(`${key}[${idx}].fileContentType`, d.fileContentType);
                formData.append(`${key}[${idx}].fileLength`, d.fileLength);
                formData.append(`${key}[${idx}].filename`, d.filename);
            })
            continue;
        }

        if (key === "deletedTerminationAttachments" && itemInEdit.deletedTerminationAttachments) {
            itemInEdit.deletedTerminationAttachments.forEach((d, idx) => {
                formData.append(`${key}[${idx}]`, d);
            })
            continue;
        }
        
        if (key === "terminationAssessmentItems") {
            itemInEdit.terminationAssessmentItems.forEach((d, idx) => {
                let keyFound = false;

                for (let dkey in d) {
                    if (typeof d[dkey] === "object")
                        continue;

                    if (dkey === "terminationAssessmentItemId") {
                        formData.append(`${key}[${idx}].${dkey}`, d.terminationAssessmentItemId ? d.terminationAssessmentItemId : 0);
                        continue;
                    }

                    if (d[dkey] && dkey !== "terminationId")
                        formData.append(`${key}[${idx}].${dkey}`, d[dkey]);

                    if (!keyFound)
                    {
                        formData.append(`${key}[${idx}].terminationId`, itemInEdit.terminationId ?? 0);
                        keyFound = true;
                    }
                }

                if (d.employeeAssessmentItemName.toLowerCase().includes("suitable for rehire"))
                    formData.append("rehireSuitability", d.assessmentValue ? true : false);
            })
            continue;
        }
    }

    if (!saveOnApproval || !approvalId)
        return formData;

    formData.append("approved", approved);
    formData.append("terminationApprovalId", approvalId);
    formData.append("includeApprovalProcess", "true");
    formData.append("statusValue", approved ? "Approved" : "Declined");

    if (!itemInEdit?.approvalReason)
        return formData;

    formData.append("approvalReason", itemInEdit.approvalReason);
    return formData;
};

export const returnToList = (history) => {
    history.push("/ecclist?mode=exit");
};

export const returnToApprovalList = (history) => {
    history.push("/eccapprovallist?mode=exit");
};
